import {Box, Modal} from '../../../ui-library';
import React from 'react';
import {
    ButtonsBox,
    LabelTitle,
    ModalBox,
    ModalTitle,
    ContentTitle,
    StartBtn,
    NumOfImages,
    OutTrainClassChip,
    ClassesBox,
    ImagesIcon,
    ClassContainer,
    CancelBtn,
    InTrainClassChip,
    TitlesDataBox,
    BoldLabelTitle,
    CustomTooltip
} from '../Style/AutoStartTrainingModal.style';
import {_SYSTEM_TITLES} from '../../../configuration/SystemTitles/SystemTitles.config';
import {ClassFlowPhase} from '../../../pages/AutoProject/Config/AutoProject.constants';
import useAutoStartTrainingModal from '../Controller/AutoStartTrainingModal.controller';
import {IPropsView, MAX_LEN_ANALYSIS_NAME} from '../Config/AutoStartTrainingModal.types';
import utilService from '../../../services/utilService';


const AutoStartTrainingModalView = ({autoProjectState, open, setOpen, startTrainingBtn, setValue}: IPropsView) => {
    const {handleStartTrainingBtn} = useAutoStartTrainingModal({setValue, startTrainingBtn, setOpen});
    const isExcludedClasses = (autoProjectState.classes.some((cur) => cur.flowPhase !== ClassFlowPhase.TrainingReady));
    const {originalStr, isSliced, shortStr} = utilService.normalizedStingWithReturn(autoProjectState.projectName, MAX_LEN_ANALYSIS_NAME);


    return (
        <>
            <Modal
                open={open}>
                <>
                    <ModalBox>
                        <TitlesDataBox>
                            <ModalTitle>{_SYSTEM_TITLES.autoExecuteTrainingTitle}</ModalTitle>
                            <LabelTitle>{_SYSTEM_TITLES.autoExecuteTrainingSubTitle}
                                {isSliced ? <CustomTooltip title={originalStr} placement='top'>
                                    <Box>
                                        <BoldLabelTitle>
                                            {shortStr}
                                        </BoldLabelTitle>
                                    </Box>
                                </CustomTooltip> : <BoldLabelTitle>
                                    {originalStr}
                                </BoldLabelTitle>}
                            </LabelTitle>
                            <ContentTitle>{_SYSTEM_TITLES.autoExecuteTrainingIncludedClassesTitle}</ContentTitle>
                        </TitlesDataBox>
                        {autoProjectState.classes && <ClassesBox>
                            {autoProjectState.classes.map((tag, index) => (
                                tag.flowPhase === ClassFlowPhase.TrainingReady && <ClassContainer key={index}>
                                    <InTrainClassChip
                                        key={index}
                                        label={tag.tag_name}/>
                                    <ImagesIcon/>
                                    <NumOfImages>
                                        {tag.readyImagesCounter}
                                    </NumOfImages>
                                </ClassContainer>
                            ))}
                        </ClassesBox>}
                        {isExcludedClasses &&
                            <>
                                <ContentTitle>{_SYSTEM_TITLES.autoExecuteTrainingExcludedClassesTitle}</ContentTitle>
                                <ClassesBox>
                                    {autoProjectState.classes.map((tag, index) => (
                                        tag.flowPhase !== ClassFlowPhase.TrainingReady && <OutTrainClassChip
                                            key={index}
                                            label={tag.tag_name}/>
                                    ))}
                                </ClassesBox>
                            </>}
                        <ButtonsBox>
                            <CancelBtn size='medium' onClick={() => setOpen(false)}>{_SYSTEM_TITLES.autoExecuteTrainingCancelBtn}</CancelBtn>
                            <StartBtn size='medium' onClick={handleStartTrainingBtn}>{_SYSTEM_TITLES.autoExecuteTrainingBtn}</StartBtn>
                        </ButtonsBox>
                    </ModalBox>
                </>
            </Modal>
        </>);
};

export default AutoStartTrainingModalView;
